import { PageTypes, SummaryPageTypes } from '@shared/types';
export function isSummaryRelevantFieldType(type) {
    return [
        PageTypes.delivery,
        PageTypes.tags,
        PageTypes.processing_sheet,
        PageTypes.processing_tags,
        SummaryPageTypes.summary_list
    ].includes(type);
}
